import { I_CLASS_MINIMUM } from '../../flows/shared/utils';
import { minimumSummitIClassInvestAmount } from '../../flows/shared/summit.utils';

export const checkIClassValidation = amount => amount < I_CLASS_MINIMUM;

export const checkSummitIClassValidation = amount =>
  amount < minimumSummitIClassInvestAmount;
